import React, { useEffect, useState } from "react";
import { dateFormats, toUtc } from "@payping/utils/dateUtils";

import { useAppSelector } from "@/utils/redux";
import ProfileCompletion from "./ProfileCompletion";
import Referral from "./Referral";
import TransactionRemaining from "./TransactionRemaining";

const ProfileProgress: React.FC = () => {
  const [visibleRemainingTransaction, setVisibleRemainingTransaction] = useState<boolean>(false);
  const { checksPercent, referralCode, haveTerminal } = useAppSelector((state) => ({
    checksPercent: state.user.checks?.percentComplete,
    haveTerminal: state.user.personalInfo?.haveTerminal,
    referralCode: state.user?.referralCode,
  }));
  const transactionCount = useAppSelector((state) => state.reports.totalTransactionCount);
  const registerDateTime = useAppSelector((state) => state.user.registerDateTime);
  const isReferralActive = useAppSelector((state) => state.user.isReferralActive);
  // start of Aban 22th
  const startDate = "2021-11-13T00:00:00.000";
  // end of Azar 2nd
  const endDate = "2021-11-23T23:59:59.999";

  /**
   * This value indicate that user can see referralCard or not. It is visible if only:
   * - User has activate terminal (`haveTerminal` === `true`)
   * - The user has completed his/her information to an acceptable extent (`checksPercent` >== `60`)
   */
  const isReferralCardVisible = haveTerminal && checksPercent && checksPercent >= 60;

  useEffect(() => {
    if (
      toUtc({ date: registerDateTime, dateFormat: dateFormats.standard.utcDateTime }).object?.isBetween(
        startDate,
        endDate
      ) &&
      haveTerminal &&
      typeof transactionCount === "number" &&
      transactionCount <= 5
    ) {
      setVisibleRemainingTransaction(true);
    } else {
      setVisibleRemainingTransaction(false);
    }
  }, [registerDateTime, haveTerminal, transactionCount]);

  // eslint-disable-next-line no-nested-ternary
  return visibleRemainingTransaction ? (
    <TransactionRemaining count={transactionCount || 0} />
  ) : isReferralCardVisible ? (
    <Referral referralCode={referralCode} isReferralActive={isReferralActive} />
  ) : (
    <ProfileCompletion checksPercent={checksPercent} />
  );
};

export default ProfileProgress;
